import { Subject } from "rxjs";
import { ExposedOutletArgument } from "./decorators";
import { filterMap } from "./filters";
import { observableToSubject } from "./util";
import { DefaultLogger } from "../../logger";
import { EventConnectionCondition } from "@citychallenge/common";

/**
 * Evaluate the conditions and returns a new subject with the condition applied onto them
 */
export function evaluateConditions(
  conditions: { [key: string]: EventConnectionCondition },
  subject: Subject<any>,
  outletArguments: { [key: string]: ExposedOutletArgument }
): Subject<any> {
  let returnSubject = subject;
  for (const [argumentName, condition] of Object.entries(conditions)) {
    const argType = outletArguments[argumentName];
    if (!argType) {
      DefaultLogger.captureException(
        new Error(
          `Could not resolve Accepts type for ${argumentName}, check in the outlet arguments if it exists.`
        ),
        "Warning"
      );
      continue;
    }

    const argTypeStr = typeof argType === "string" ? argType : argType.type;

    const filter = filterMap[argTypeStr];

    if (filter) {
      const obs = filter(subject, argumentName, condition.target, {
        operator: condition.comparator,
      });
      // Reconvert to subject so that  we can chain it a second time
      returnSubject = observableToSubject(obs);
    } else {
      DefaultLogger.captureException(
        new Error(
          `Outlet condition filter for argument with type ${argTypeStr} has no matching filter in the filterMap.`
        ),
        "Warning"
      );
    }
  }
  return returnSubject;
}
